var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-img-container"},[_vm._l((_vm.list),function(src,index){return [(index < _vm.limit)?_c('img',{directives:[{name:"viewerer",rawName:"v-viewerer",value:(_vm.list),expression:"list"}],key:index,attrs:{"src":_vm._f("ossStyle")(src,_vm.width),"width":_vm.width,"alt":""}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }